import { Component, OnInit } from '@angular/core';

import { InfoService } from 'src/app/services/';
import { DataInfo } from 'src/app/models';

@Component({
  selector: 'app-info-dialog',
  templateUrl: './info-dialog.component.html',
  styleUrls: ['./info-dialog.component.scss'],
})
export class InfoDialogComponent implements OnInit {
  dataInfo: DataInfo | null = null;

  constructor(private infoService: InfoService) {}

  ngOnInit(): void {
    this.infoService.getDataInfo().subscribe((info) => (this.dataInfo = info));
  }
}
